import BusinessCreatePage from './BusinessCreatePage';

export default BusinessCreatePage;
